import { ActivitySubject, AllSubjects } from "./ActivitySubjects";
import type { CurriculumSubject } from "./ActivitySubjects";

export const ActivityStandard = {
  CCSS: "Common Core State Standards (CCSS)",
  NGSS: "Next Generation Science Standards (NGSS)",
  NCSS: "National Curriculum Standards for Social Studies (NCSS)",
  AP: "Advanced Placement (AP) Standards",
  IB: "International Baccalaureate (IB) Standards",
  StateSpecific: "State-Specific Standards",
  Other: "Other",
} as const;

export type ActivityStandardValue =
  (typeof ActivityStandard)[keyof typeof ActivityStandard];

export const ActivityStandardsBySubject: Record<
  CurriculumSubject,
  ActivityStandardValue[]
> = {
  [ActivitySubject.Math]: [
    ActivityStandard.CCSS,
    ActivityStandard.AP,
    ActivityStandard.IB,
    ActivityStandard.StateSpecific,
    ActivityStandard.Other,
  ],
  [ActivitySubject.English]: [
    ActivityStandard.CCSS,
    ActivityStandard.AP,
    ActivityStandard.IB,
    ActivityStandard.StateSpecific,
    ActivityStandard.Other,
  ],
  [ActivitySubject.ScienceAndNature]: [
    ActivityStandard.NGSS,
    ActivityStandard.AP,
    ActivityStandard.IB,
    ActivityStandard.StateSpecific,
    ActivityStandard.Other,
  ],
  [ActivitySubject.SocialStudies]: [
    ActivityStandard.NCSS,
    ActivityStandard.AP,
    ActivityStandard.IB,
    ActivityStandard.StateSpecific,
    ActivityStandard.Other,
  ],
  [ActivitySubject.EarlyEducation]: [
    ActivityStandard.StateSpecific,
    ActivityStandard.Other,
  ],
  [AllSubjects]: [
    ActivityStandard.CCSS,
    ActivityStandard.NGSS,
    ActivityStandard.NCSS,
    ActivityStandard.AP,
    ActivityStandard.IB,
    ActivityStandard.StateSpecific,
    ActivityStandard.Other,
  ],
};

export function isActivityStandard(
  standard: string,
): standard is ActivityStandardValue {
  return Object.values(ActivityStandard).includes(standard as any);
}
